var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNovuinline = function SvgNovuinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.86 7.699a.54.54 0 0 1-.926.377L6.005.995A9 9 0 0 1 9 .485c1.79 0 3.458.522 4.86 1.423zm2.52-3.367v3.367c0 2.742-3.33 4.1-5.247 2.14L3.68 2.223A8.99 8.99 0 0 0 0 9.484c0 1.917.599 3.693 1.62 5.153v-3.35c0-2.741 3.33-4.1 5.247-2.14l7.441 7.606A8.99 8.99 0 0 0 18 9.484a8.96 8.96 0 0 0-1.62-5.152M5.066 10.91l6.916 7.069A9 9 0 0 1 9 18.484a8.96 8.96 0 0 1-4.86-1.423v-5.773a.54.54 0 0 1 .926-.378"
  })));
};
export default SvgNovuinline;